import { render, staticRenderFns } from "./GraduationHat.vue?vue&type=template&id=56cff32c&"
import script from "./GraduationHat.vue?vue&type=script&lang=js&"
export * from "./GraduationHat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports